import { get, pick } from 'lodash';
import {
  PICKUP_POINT_AMENITIES_TYPE,
  PICKUP_POINT_TYPE,
} from '../../constants/pickupPoint';

export const getPickupFilteredJSON = (pickupPoint, criteria) => {
  const pickupGeoServiceCodes = get(
    pickupPoint,
    'pickupLocation.geoServiceCode',
    []
  );

  if (criteria === PICKUP_POINT_AMENITIES_TYPE.LABEL_PRINTING) {
    return (
      get(pickupPoint, 'pickupLocation.dropOffDigital') ||
      pickupGeoServiceCodes.includes('204')
    );
  }

  return pick(get(pickupPoint, 'pickupLocation'), [
    PICKUP_POINT_AMENITIES_TYPE.WHEELCHAIR_ACCESS,
    PICKUP_POINT_AMENITIES_TYPE.CAR_PARKING,
    PICKUP_POINT_AMENITIES_TYPE.OPEN_LATE,
    PICKUP_POINT_AMENITIES_TYPE.OPEN_SATURDAYS,
    PICKUP_POINT_AMENITIES_TYPE.OPEN_SUNDAYS,
  ])[criteria];
};

export const isDropdownMenuOverflowing = (anchorEl, menuHeight = 0) => {
  if (!anchorEl) {
    return false;
  }
  return (
    anchorEl &&
    anchorEl.getBoundingClientRect().bottom + menuHeight > window.innerHeight
  );
};

export const getKindLabel = kind =>
  Object.keys(PICKUP_POINT_TYPE).find(key => PICKUP_POINT_TYPE[key] === kind) ||
  kind;
